import axios from "axios";
import Config from "../../../config";

const v2_actionDeleteScoringDefinition = (scoringId) => {
    return axios({
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/crm/scoring/definitions/${scoringId}/deletar`,
    });
};

export default v2_actionDeleteScoringDefinition;
